import { Main, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { JackpotOutroView } from "./Jackpot/JakcpotOutro/JackpotOutroView";
import { dispatcher, ingenuity } from "@quest/base-core";
import { eventDispatchers } from "./Constants/EventDispatchers";
import { JackpotOutroController } from "./Jackpot/JakcpotOutro/JackpotOutroController";

export class MainGame extends Main {
  private jackpotOutroView: JackpotOutroView;

  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.INITIALIZE_JACKPOT, this.initializeJackpot, this);
  }

  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.INITIALIZE_JACKPOT, this.initializeJackpot, this);
  }
  //to intiialize jackpot view
  private initializeJackpot(): void {
    if (!this.jackpotOutroView) {
      this.jackpotOutroView = new JackpotOutroView(
        ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).jackpotIntroOutro
      );
      new JackpotOutroController(this.jackpotOutroView);
    }
    ingenuity.currentGame.stage.addChild(this.jackpotOutroView);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
  }
}
